import React from 'react';

export const VideoGateContext = React.createContext({
  registerVideoRequirement: () => {},
  markVideoCompleted: () => {},
  registerQuizRequirement: () => {},
  markQuizPassed: () => {},
  registerActivityRequirement: () => {},
  markActivityCompleted: () => {},
});
